export default "__VITE_ASSET__C743uIQc__"